import { render, staticRenderFns } from "./HolidaySettingsModal.vue?vue&type=template&id=35d4fcde&scoped=true&"
import script from "./HolidaySettingsModal.vue?vue&type=script&lang=js&"
export * from "./HolidaySettingsModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "35d4fcde",
  null
  
)

export default component.exports